import { create } from "zustand";

type EventsState = {
  event: string;
  setEvent: (event: string) => void;
};

export const useEventsStore = create<EventsState>((set) => ({
  event: "activity",
  setEvent: (event: string) => set({ event }),
}));
